import axios from "axios";

const TOKEN_URL = `https://apis.anahealth.app/auth/service/token`;

type TokenResponse =
  | { token?: string }
  | { access_token?: string }
  | { result?: { token?: string } }
  | Record<string, unknown>;

export default async function fetchCrmToken(): Promise<string | null> {
  const payload = {
    service_id: "whoqol_app",
    service_secret: "yLhqyGPEXYF7Bpqz6LJ/RIjUI019/beRZYkd8o/HX5U=",
    scopes: ["crm_api"],
  };

  try {
    const { data } = await axios.post<TokenResponse>(TOKEN_URL, payload, {
      headers: { "Content-Type": "application/json" },
    });
    const token =
      (data as any)?.token ?? (data as any)?.access_token ?? (data as any)?.result?.token;
    return token ?? null;
  } catch {
    return null;
  }
}


